import { render, staticRenderFns } from "./sellVoucher.vue?vue&type=template&id=40a67d94&scoped=true&"
import script from "./sellVoucher.vue?vue&type=script&lang=js&"
export * from "./sellVoucher.vue?vue&type=script&lang=js&"
import style0 from "./sellVoucher.vue?vue&type=style&index=0&id=40a67d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a67d94",
  null
  
)

export default component.exports